import { HomeTemplate } from "components/templates"

const Home = (): JSX.Element => {
  return <HomeTemplate />
}

export default Home
